// extracted by mini-css-extract-plugin
export var formContainer = "_fk-0";
export var message = "_fk-1";